import { observable, action } from "mobx";
import { post, get, deleted, put } from "../services/ajax.service";

class TemplateStore {
  @observable templates_all = [];
  @observable templates_by_type = [];
  @observable limit = 10;
  @observable logs_limit = 10;
  @observable tiles = 0;
  @observable log_tiles = 0;
  @observable errors = {};
  @observable url = "/api/v1/templateActions";

  @action setTemplateEmpty=()=>{
    this.templates_by_type=[];
  }

  @action getTemplates = async (data) => {
    try {
      let templates_all = [];
      let response = await get(
        `${this.url}/getall?limit=${this.limit}&&offset=${data.offset}`
      );

      this.templates_all = response.data.rows;
      let count = parseInt(response.data.count);
      this.tiles =
        count % this.limit == 0
          ? parseInt(count / this.limit)
          : parseInt(count / this.limit) + 1;
    } catch (err) {
      this.errors = err.response.data;
    }
  };

  @action getTemplate = async (id) => {
    try {
      let templates = [];

      let response = await get(`${this.url}/get/${id}`);
      this.templates = response.data
      return response.data
    } catch (err) {
      this.errors = err.response.data;
    }
  };

  @action getTemplateByType = async (type) => {
    try {
      let templates_by_type = [];

      let response = await get(`${this.url}/getTemplateByType/${type}`);

      this.templates_by_type = response.data;
      return response.data;
    } catch (err) {
      this.errors = err.response.data;
    }
  };

  @action addTemplate = async (data) => {
    try {
      let  response = await post(`${this.url}/create`, data);
      return response;

    } catch (e) {
      this.errors = e.response.data;
    }
  };
  @action deleteTemplate = async (id, history) => {
    try {
      await deleted(`${this.url}/delete/${id}`);
      var filtered = this.templates.filter(template => template.id !== id);
      this.templates = filtered;
    } catch (e) {
      console.log(e);
    }
  };

  @action editTemplate = async (data,id,history) => {
    try {
     let response= await put(`${this.url}/update/${id}`, data);

      this.action = true;
      return response.data
    } catch (e) {
      this.errors = e.response.data;
      return e.response.data
    }
  };
}

export default TemplateStore;
